import React from 'react';
import InlineColorPreview from '../components/InlineColorPreview';

export default class ColorUtil {
  // Source: https://css-tricks.com/snippets/javascript/lighten-darken-color/
  static lightenDarkenColor = (col, amt) => {
    let usePound = false;

    if (col[0] === "#") {
      col = col.slice(1);
      usePound = true;
    }

    const num = parseInt(col, 16);

    let r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;

    let b = ((num >> 8) & 0x00FF) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;

    let g = (num & 0x0000FF) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;

    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16).padStart(6, "0");
  }

  static addInlineColorPreviews = text => {
    if (!text)
      return "";

    const parts = text.split('#');
    const result = [parts[0]];
    for (let i = 1; i < parts.length; i++) {
      const part = parts[i];
      if (part.length >= 6) {
        const color = '#' + part.substring(0, 6);
        result.push(<InlineColorPreview color={color} />);
        if (part.length > 6)
          result.push(part.substring(6));
      } else {
        result.push(part);
      }
    }
    return result;
  }
  
}